import { Container, Grid } from "@mui/material";
import ScreenBanner from "../../components/ScreenBanner";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../components/ListaAcoesRapidas";
import { useNavigate } from "react-router";
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import { useContext, useState } from "react";
import CardDadosDashboard from "./components/MIDashboard/CardDadosDashboard";
import { AuthContext } from "../../contexts/AuthContext";
import { TLoja } from "../../components/SelectsSimpleApiQuery/SelectLojaComPesquisa";
import { useQuery } from "react-query";
import axiosClient from "../../lib/axios";
import { IDataDashboardReceituario } from "../../types/api/receituarioAgronomico/dashboard-receituario";
import CardReceitas from "./components/MIDashboard/CardReceitas";
import CardListagemTecnicos from "./components/MIDashboard/CardListagemTecnicos/indext";
import ReceituarioLoading from "./ReceituarioLoading";
import PermissionGuard, { usePermission } from "../../components/PermissionGuard";

export default function ReceituarioAgronomico() {
    const navigate = useNavigate();
    const { userPerfilComLoja } = useContext(AuthContext);

    const lojaDoContexto = userPerfilComLoja?.loja
        ? { id: userPerfilComLoja.loja.id, nome: userPerfilComLoja.loja.nome }
        : null;

    const [loja, setLoja] = useState<TLoja | null>(lojaDoContexto);

    // Query
    const { data: dashboardReceituario, isLoading: isLoadingDashboard } = useQuery({
        queryKey: ["pesquisar-dashboard-receituario-agronomico", loja?.id],
        queryFn: () => axiosClient.get("/receituario-agronomico/dashboard", {
            params: {
                loja_id: loja?.id
            }
        }),
        enabled: Boolean(loja),
        refetchOnWindowFocus: true,
        staleTime: 0
    });
    const dataDashboard: IDataDashboardReceituario = dashboardReceituario?.data || null;

    const listaAcoesRapidas: Array<TItemAcaoRapida> = [
        {
            label: "Listar agronômos",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate('/receituario-agronomico/agronomo/listar-todos'),
            havePermission: usePermission("receituario.listar-agronomos")
        },
        {
            label: "Listar culturas",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate('/receituario-agronomico/culturas/listar-todos'),
            havePermission: usePermission("receituario.listar-culturas")
        },
        {
            label: "Listar pragas",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate('/receituario-agronomico/pragas/listar-todos'),
            havePermission: usePermission("receituario.listar-pragas")
        },
        {
            label: "Listar ingredientes ativos",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate('/receituario-agronomico/ingredientes-ativos/listar-todos'),
            havePermission: usePermission("receituario.listar-ingredientes-ativos")
        },
        {
            label: "Listar agrotóxicos",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate('/receituario-agronomico/agrotóxicos/listar-todos'),
            havePermission: usePermission("receituario.listar-agrotoxicos")
        },
    ];


    return (
        <>
            <ScreenBanner title="Receituário Agronômico" />
            <PermissionGuard permissionId="receituario.dashboard">
                <Container>
                    {
                        isLoadingDashboard &&
                        <ReceituarioLoading />
                    }
                    {
                        !isLoadingDashboard &&
                        <Grid container spacing={2} mt={2}>
                            <Grid size={{xs: 12, md: 4}}>
                                <ListaAcoesRapidas
                                    scrollable
                                    height="150px"
                                    items={listaAcoesRapidas}
                                />
                            </Grid>
                            <Grid size={{xs: 12, md: 8}}>
                                <CardDadosDashboard
                                    loja={loja}
                                    dataDashboard={dataDashboard}
                                    onChangeLoja={novaLoja => setLoja(novaLoja)}
                                />
                            </Grid>
                            {dataDashboard && (
                                <>
                                    <Grid size={{xs: 12, md: 6}}>
                                        <CardReceitas dataDashboard={dataDashboard} />
                                    </Grid>
                                    <Grid size={{xs: 12, md: 6}}>
                                        <CardListagemTecnicos dataDashboard={dataDashboard} />
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    }
                </Container>
            </PermissionGuard>
        </>
    );
}